export default function setBodyColor({ color }) {
    document.documentElement.style.setProperty('--grey05', color)
}